import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FilterCloseIcon from "../../assets/filter-close.svg";
import FilterselectIcon from "../../assets/filter-blue.svg";
import { Dropdown, Button } from "antd";
import { Checkbox } from "@vds/checkboxes";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

function DropdownMultiFilterWithCheckboxAndInitialValue(props) {
  const { text, menuItems = [], isSortable, onReset, onApply,accountId } = props;
  const [filters, setFilters] = useState(() => {
    let intialFilters = {};
    menuItems?.forEach((menuItem) => {
      intialFilters = {
        ...intialFilters,
        [menuItem.text]: menuItem.value,
      };
    });
    return {
      isOpen: false,
      isAsc: true,
      isFilterBoxOpen: null,
      filters: intialFilters,
    };
  });

  useEffect(() => {
      let intialFilters = {};
      menuItems?.forEach((menuItem) => {
        intialFilters = {
          ...intialFilters,
          [menuItem.text]: menuItem.value,
        };
      });
      setFilters((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          ...intialFilters,
        },
      }));
    }, [menuItems,accountId]);
    // useEffect(() => {
    //     setFilters((prev) => ({
    //       ...prev,
    //       filters: { ...prev.filters,text: "" },
    //     }));
    //   }, [accountId]);

  let items = [];
  const sortableMenus = [
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("asc");
          }}
          className={
            filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort ascending
          <ArrowUpOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("desc");
          }}
          className={
            !filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort descending
          <ArrowDownOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
  ];

  const menus = menuItems?.map((menuItem, index) => {
    if (menuItem.value === "header") {
      return {
        label: (
          <div>
            <span className="font-face-vzw ats-filter-header">
              {menuItem.text}
            </span>
          </div>
        ),
        key: `${index + 1}`,
      };
    }
    return {
      label: menuItems && (
        <Checkbox
          className="filter-checkbox"
          selected={filters?.filters[menuItem.text]}
          onChange={(e) => {
            handleCheckboxChange(menuItem.text);
          }}
        >
          {menuItem?.text}
        </Checkbox>
      ),
      key: `${index + 1}`,
    };
  });

  menus?.push({
    label: (
      <div className="ats-filter-footer">
        <button onClick={handleReset} className="reset-filter">
          Reset filter
        </button>
        <Button
          onClick={handleApplyFilter}
          className="ats-filter-footer-button"
          color="default"
          variant="solid"
        >
          Apply
        </Button>
      </div>
    ),
  });

  if (isSortable) {
    items = [
      ...sortableMenus,
      {
        label: (
          <div>
            <span className="font-face-vzw ats-filter-header">Filter</span>
          </div>
        ),
      },
      ...menus,
    ];
  } else {
    items = [
      {
        label: (
          <div>
            <span className="font-face-vzw ats-filter-header">Filter</span>
          </div>
        ),
      },
      ...menus,
    ];
  }

  const handleSort = (val) => {
    if (val === "asc") {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: true }));
    } else {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: false }));
    }
  };

  function handleReset(e) {
    e.preventDefault();
    setFilters((prev) => {
      let filters = {...prev.filters};
      const filterKeys = Object.entries(prev.filters).filter((filter) => filter[1] !== "header");
      filterKeys?.forEach((filtersKey) => {
        filters = {
          ...filters,
          [filtersKey[0]]: false,
        };
      });
      return { ...prev, isAsc: true, filters: filters, isFilterBoxOpen: true, isOpen: false  };
    });
    onReset({ filters: filters.filters, isAsc: filters.isAsc });
  }

  function handleApplyFilter(e) {
    e.preventDefault();
    setFilters((prev) => ({ ...prev, isFilterBoxOpen: false, isOpen: false }));
    onApply({ filters: filters.filters, isAsc: filters.isAsc });
  }

  const handleCheckboxChange = (val) => {
    setFilters((prev) => ({
      ...prev,
      isFilterBoxOpen: true,
      filters: {
        ...prev.filters,
        [val]: !prev.filters[val],
      },
    }));
  };

  const handleOpenChange = (val) => {
    if (val === false) {
      if (filters?.isOpen === true) {
        setFilters((prev) => ({ ...prev, isFilterBoxOpen: null, isOpen: val }));
      }
    } else {
      setFilters((prev) => ({ ...prev, isOpen: val }));
    }
  };
  function isAnyFilterTrue(data) {
    return Object.values(data).some((value) => value === true);
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      open={filters.isOpen}
      overlayClassName="ats-filter-overlay"
    >
      <div className="ats-filter">
        <span className="font-face-vzw">{text}</span>
        <img
          src={
            filters.isOpen || isAnyFilterTrue(filters?.filters)
              ? FilterselectIcon
              : FilterCloseIcon
          }
          alt="filter-icon"
        />
      </div>
    </Dropdown>
  );
}

DropdownMultiFilterWithCheckboxAndInitialValue.propTypes = {
  text: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired || PropTypes.string.isRequired,
    })
  ).isRequired,
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default DropdownMultiFilterWithCheckboxAndInitialValue;
